module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_tiempo_1960.f9f023f7.jpg";